import React, { Component } from "react";
import queryString from "query-string";

import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import { formatNumber } from "../../utils/helpers";
import dayjs from "dayjs";
import Loader from "../general/Loader";

export default class ReporteDetalleProduccionRutas extends Component {
    state = {
        rutas: false,
    };
    componentDidMount() {
        this.getReporte();
    }
    getReporte = async () => {
        const token = auth.getToken();

        const res = await fetch(apiUrl(`reportes` + window.location.search), {
            method: "get",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.setState({
                rutas: response.data,
            });
        }

        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    render() {
        const { rutas } = this.state;

        if (!rutas) {
            return <Loader />;
        }

        const user = auth.getUser();
        const sucursal = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];
        const query = queryString.parse(window.location.search);

        const totalViajes = rutas.reduce((acc, ruta) => {
            return acc + parseFloat(ruta.viajes);
        }, 0);

        const totalTon = rutas.reduce((acc, ruta) => {
            return acc + parseFloat(ruta.toneladas);
        }, 0);

        return (
            <div>
                <div className='row'>
                    <h2 className='col-md-12 text-center m-b-5'>
                        Detalle Producción por Rutas
                    </h2>
                    <div className='col-md-12 text-center'>
                        {sucursal.nombre} - {sucursal.direccion} •{" "}
                        {dayjs(query.desde).format("DD/MM/YYYY")} -{" "}
                        {dayjs(query.hasta).format("DD/MM/YYYY")}
                    </div>
                    <div className='col-md-12 p-b-10'></div>
                    <div className='col-md-12 text-right p-b-10'>
                        <div className='float-left'>RUTAS: {rutas.length}</div>

                        <div className='float-right'>
                            <h3>
                                <span className='m-r-25'>
                                    TOTAL VIAJES: {totalViajes}
                                </span>{" "}
                                TOTAL TON: {formatNumber(totalTon)}
                            </h3>
                        </div>
                    </div>
                </div>

                {rutas.map((ruta) => {
                    return (
                        <div key={ruta.id} className='m-b-25'>
                            <h3>
                                {ruta.nombre} - {ruta.descripcion}
                            </h3>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th style={{ width: "100px" }}>
                                            Fecha
                                        </th>
                                        <th style={{ width: "90px" }}>Ficha</th>
                                        <th>Chofer</th>
                                        <th
                                            style={{ width: "100px" }}
                                            className='text-center'>
                                            Viajes
                                        </th>
                                        <th
                                            style={{ width: "100px" }}
                                            className='text-right'>
                                            TON.
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ruta.tarjetas.map((tarjeta) => {
                                        return (
                                            <tr key={tarjeta.id}>
                                                <td>
                                                    {dayjs(
                                                        tarjeta.fecha
                                                    ).format("DD/MM/YYYY")}
                                                </td>
                                                <td>{tarjeta.ficha}</td>
                                                <td>{tarjeta.chofer}</td>
                                                <td className='text-center'>
                                                    {tarjeta.tickets.length}
                                                </td>
                                                <td className='text-right'>
                                                    {formatNumber(
                                                        tarjeta.toneladas
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td className='text-right'>TOTALES:</td>
                                        <td className='text-center'>
                                            {ruta.viajes}
                                        </td>
                                        <td className='text-right'>
                                            {formatNumber(ruta.toneladas)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    );
                })}
                <div className='m-t-25'>
                    <div className='float-left'>RUTAS: {rutas.length}</div>
                    <div className='text-right float-right'>
                        <h3>
                            <span className='m-r-25'>
                                TOTAL VIAJES: {totalViajes}
                            </span>{" "}
                            TOTAL TON: {formatNumber(totalTon)}
                        </h3>
                    </div>
                </div>
            </div>
        );
    }
}
